import React from 'react';
import ErrorState from '@atlassian/jira-common-components-error-state/src/index.tsx';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import {
	FETCH_COMPONENTS_REASON,
	type FetchComponentsReason,
} from '../../common/constants/fetch-components-reason.tsx';

const messages = defineMessages({
	header: {
		id: 'project-components.error-header',
		defaultMessage: 'An error occurred',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	description: {
		id: 'project-components.error-description',

		defaultMessage:
			'There was a problem loading your components. Try again or contact your administrator for support.',

		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});

type Props = {
	currentPage: number;
	isLoading: boolean;
	onRetry: (arg1: { page: number; initiatedBy: FetchComponentsReason }) => void;
};

function ErrorView(props: Props) {
	const { onRetry, currentPage, isLoading } = props;
	const { formatMessage } = useIntl();
	return (
		<ErrorState
			header={formatMessage(messages.header)}
			description={formatMessage(messages.description)}
			isLoading={isLoading}
			onRetry={() =>
				onRetry({
					page: currentPage,
					initiatedBy: FETCH_COMPONENTS_REASON.VIEW,
				})
			}
		/>
	);
}

ErrorView.defaultProps = {
	isLoading: false,
};

export default ErrorView;
